export default __webpack_public_path__ + "static/media/stay-home-img.cdd0a4c7.jpg";